module.exports = __webpack_public_path__ + "img/cruk-logo.4153c569.png";